(function () {
  class ProductManager {
    constructor() {
      this.productVariants = CurrentProduct;
      this.templateName = CurrentTemplate;
      this.selectedOptions = { color: null, size: null };
      this.getUrl = window.location;
      this.swiperInstances = [];
      this.swiperInstances = [];
      this.cache = new Map();
      this.MAX_CACHE_SIZE = 5;
      this.cacheAccessOrder = [];
      this.prefetchTimeout = null; // Timeout for debounce
      this.abortController = null;

      this.elements = {};
      this.currentFetchingUrl = null;

      this.handleClick = this.handleClick.bind(this);
      this.addToCartClickHandler = this.addToCartClickHandler.bind(this);
      this.handleProductCircleClick = this.handleProductCircleClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.prefetchHandler = this.prefetchHandler.bind(this); // Bind prefetch handler

      this.accordions();
      this.init();
    }

    addToCache(key, value) {
      if (this.cache.has(key)) {
        this.cacheAccessOrder = this.cacheAccessOrder.filter(k => k !== key);
      }

      if (this.cache.size >= this.MAX_CACHE_SIZE) {
        const oldestKey = this.cacheAccessOrder.shift();
        this.cache.delete(oldestKey);
      }

      this.cache.set(key, value);
      this.cacheAccessOrder.push(key);
    }
    refreshDomElements() {
      this.elements = {
        variantColorEls: document.querySelectorAll('.variant_color'),
        variantSizeEls: document.querySelectorAll('.variant_size'),
        colorSelectedEl: document.querySelector('.color-selected'),
        sizeSelectedEl: document.querySelector('.size-selected'),
        productSelectEl: document.querySelector('#ProductSelect'),
        addToCartBtn: document.querySelector('#AddToCartBtnBsl'),
        termsCheckbox: document.querySelector('#agree-terms'),
        onlyLeftInStock: document.querySelector('#only-left-in-stock'),
        soldButton: document.querySelector('.sold-out-btn'),
        backInStock: document.querySelector('.pdp-klaviyo-trigger'),
        showRealPrice: document.querySelectorAll('.info-product-detail__pdp-price'),
        showComparePrice: document.querySelectorAll('.info-product-detail__pdp-compare-at-price'),
        floatingAddToCarBtn: document.querySelector('.floating-add-to-cart'),
        footer: document.querySelector('footer.footer-section')
      };
    }

    async init() {
      this.refreshDomElements();

      if (!this.elements.addToCartBtn) return;

      // Critical Path: Immediate user interaction (Color/Size, AddToCart) and Main Gallery
      // Execute immediately to ensure listeners are attached
      this.initCritical();

      // Deferred Path: Secondary interactions and heavier DOM manipulations
      requestAnimationFrame(() => {
        this.initDeferred();
      });
    }

    async initCritical() {
      this.removeAllListeners();
      this.attachListeners();
      this.setDefaultVariant();

      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (isMobile) {
        this.destroyAllSwipers();
        // Swiper is critical for the main gallery
        try {
          await this.waitForSwiper();
          this.initSwiperGallery();
        } catch (e) {
          console.warn('Swiper initialization failed or timed out:', e);
        }
      }

    }

    initDeferred() {
      this.removeAccordionEmpty();
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (!isMobile) {
        this.initZoomGallery();
      }

      // Re-init size guide listeners if available
      if (typeof window.initSizeGuideListeners === 'function') {
        window.initSizeGuideListeners();
      }
      //if (window.yotpo) return window.yotpo.refreshWidgets();
      if (window.initRelatedSwatches) window.initRelatedSwatches();
      this.accordions();
    }

    waitForSwiper(timeout = 5000) {
      return new Promise((resolve, reject) => {
        if (typeof Swiper !== 'undefined') {
          resolve(Swiper);
          return;
        }

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkInterval);
            resolve(Swiper);
          } else if (Date.now() - startTime > timeout) {
            clearInterval(checkInterval);
            reject(new Error('Swiper failed to load within timeout'));
          }
        }, 100);
      });
    }

    initSwiperGallery() {
      const galleryContainers = document.querySelectorAll('.gallery-main-media');

      if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded');
        return;
      }

      if (galleryContainers.length === 0) {
        console.warn('No gallery containers found with class .gallery-main-media');
        return;
      }

      galleryContainers.forEach((container, index) => {
        if (!(container instanceof HTMLElement)) {
          console.error('Invalid container element:', container);
          return;
        }


        const swiperWrapper = container.querySelector('.swiper-wrapper');
        if (!swiperWrapper) {
          console.warn('Container does not have .swiper-wrapper:', container);
          return;
        }

        const slides = swiperWrapper.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
          console.warn('No slides found in container:', container);
          return;
        }

        try {
          if (!container.classList.contains('swiper')) {
            container.classList.add('swiper');
          }

          const containerParent = container.closest('.product-pdp-gallery-media') || container.parentElement;

          const nextButton = container.querySelector('.swiper-button-next') ||
            containerParent?.querySelector('.swiper-button-next');
          const prevButton = container.querySelector('.swiper-button-prev') ||
            containerParent?.querySelector('.swiper-button-prev');
          const pagination = container.querySelector('.swiper-pagination') ||
            containerParent?.querySelector('.swiper-pagination');

          const swiperConfig = {
            loop: slides.length > 1,
            slidesPerView: 1,
            spaceBetween: 30,
            allowTouchMove: true,
            loop: true,
          };

          if (nextButton && prevButton) {
            swiperConfig.navibulletsgation = {
              nextEl: nextButton,
              prevEl: prevButton,
            };
          }

          if (pagination) {
            swiperConfig.pagination = {
              el: pagination,
              clickable: true,
              type: 'fraction',
            };
          }

          const swiperInstance = new Swiper(container, swiperConfig);

          swiperInstance.on('slideChange', () => {
            const icons = document.querySelectorAll('.image-gallery-tag');
            icons.forEach(icon => {
              icon.querySelector('.image-gallery-tag__icon').classList.remove('hide-elem');
              icon.querySelector('.image-gallery-tag__text').classList.add('hide-elem')
            });
          });

          this.swiperInstances.push({
            instance: swiperInstance,
            container: container,
            id: `gallery-swiper-${index}`
          });

        } catch (error) {
          console.error(`❌ Error initializing Swiper for container ${index}:`, error);
        }
      });

      console.log(`Total Swipers initialized: ${this.swiperInstances.length}`);
    }

    destroyAllSwipers() {
      if (this.swiperInstances.length > 0) {
        this.swiperInstances.forEach(({ instance, id }) => {
          try {
            if (instance && typeof instance.destroy === 'function') {
              instance.destroy(true, true);
              console.log(`Swiper destroyed: ${id}`);
            }
          } catch (e) {
            console.warn(`Error destroying swiper ${id}:`, e);
          }
        });
        this.swiperInstances = [];
      }
    }

    removeAllListeners() {
      if (this.elements.addToCartBtn) {
        const newBtn = this.elements.addToCartBtn.cloneNode(true);
        this.elements.addToCartBtn.parentNode.replaceChild(newBtn, this.elements.addToCartBtn);
        this.elements.addToCartBtn = newBtn;
      }
    }

    attachListeners() {
      const variantContainer = document.querySelector('.product-form__controls-group') || document.body;

      if (this.variantDelegateHandler) {
        variantContainer.removeEventListener('click', this.variantDelegateHandler);
      }

      this.variantDelegateHandler = (e) => {
        const target = e.target.closest('.variant_color, .variant_size');
        if (target) {
          this.handleClick(e, target);
        }
      };

      variantContainer.addEventListener('click', this.variantDelegateHandler);

      if (this.elements.addToCartBtn) {
        this.elements.addToCartBtn.addEventListener('click', this.addToCartClickHandler);
      }

      if (this.elements.termsCheckbox && this.elements.addToCartBtn) {
        const btn = this.elements.addToCartBtn;
        const cb = this.elements.termsCheckbox;

        const originalText = btn.dataset.originalText || btn.innerHTML.trim();
        const termsText = btn.dataset.termsText || 'Agree and Check Box Below to Proceed';

        if (this.termsDelegateHandler) {
          cb.removeEventListener('change', this.termsDelegateHandler);
        }

        this.termsDelegateHandler = () => {
          const floatingBtn = this.elements.floatingAddToCarBtn;
          const shopPayBtn = document.querySelector('.shopify-payment-button');
          const shopPayContainer = document.querySelector('.shop-pay-contianer');

          if (cb.checked) {
            btn.classList.remove('disabled-terms');
            btn.innerHTML = originalText;
            btn.disabled = false;
            if (floatingBtn) floatingBtn.classList.remove('disabled-terms');
            if (shopPayBtn) shopPayBtn.classList.remove('disabled-terms');
            if (shopPayContainer) shopPayContainer.classList.remove('disabled-terms');
          } else {
            btn.classList.add('disabled-terms');
            btn.innerHTML = termsText;
            btn.disabled = true;
            if (floatingBtn) floatingBtn.classList.add('disabled-terms');
            if (shopPayBtn) shopPayBtn.classList.add('disabled-terms');
            if (shopPayContainer) shopPayContainer.classList.add('disabled-terms');
          }
        };

        cb.addEventListener('change', this.termsDelegateHandler);
        this.termsDelegateHandler();
      }

      if (this.elements.floatingAddToCarBtn && this.elements.addToCartBtn) {
        this.elements.floatingAddToCarBtn.addEventListener('click', () => {
          this.elements.addToCartBtn.click();
        });
      }

      const productCircleContainer = document.querySelector('.product-circles') || document.body;

      if (this.productCircleDelegateHandler) {
        productCircleContainer.removeEventListener('click', this.productCircleDelegateHandler);
      }

      this.productCircleDelegateHandler = (e) => {
        const target = e.target.closest('a.product-circle-item');

        if (target) {
          this.handleProductCircleClick(e, target);

          productCircleContainer.querySelectorAll('a.product-circle-item').forEach(item => {
            if (item !== target) {
              item.classList.remove('active');
            }
          });

          target.classList.add('active');
        }
      };

      productCircleContainer.addEventListener('click', this.productCircleDelegateHandler);

      document.removeEventListener('scroll', this.handleScroll);
      document.addEventListener('scroll', this.handleScroll);

      const galleryContainer = document.querySelector('.product-pdp-gallery-media') || document.body;

      if (this.galleryTagDelegateHandler) {
        galleryContainer.removeEventListener('click', this.galleryTagDelegateHandler);
      }

      this.galleryTagDelegateHandler = (e) => {
        const target = e.target.closest('.image-gallery-tag');
        if (target) {
          const tagButton = target.querySelector('.image-gallery-tag__icon');
          const tagText = target.querySelector('.image-gallery-tag__text');
          tagButton?.classList.toggle('hide-elem');
          tagText?.classList.toggle('hide-elem');
        }
      };

      galleryContainer.addEventListener('click', this.galleryTagDelegateHandler);

      // Add Prefetch Listeners
      const productCircleContainer2 = document.querySelector('.product-circles') || document.body;
      if (this.prefetchDelegateHandler) {
        productCircleContainer2.removeEventListener('mouseenter', this.prefetchDelegateHandler, true);
      }

      this.prefetchDelegateHandler = (e) => {
        const target = e.target.closest('a.product-circle-item');
        if (target) {
          clearTimeout(this.prefetchTimeout); // Clear previous timeout
          this.prefetchTimeout = setTimeout(() => {
            this.prefetchHandler(target);
          }, 200); // Wait 200ms before triggering
        }
      }

      const clearPrefetchTimeout = () => {
        clearTimeout(this.prefetchTimeout);
      };

      productCircleContainer2.addEventListener('mouseover', this.prefetchDelegateHandler);
      productCircleContainer2.addEventListener('mouseout', clearPrefetchTimeout);

    }

    prefetchHandler(target) {
      const urlProd = target.getAttribute('href');
      if (!urlProd) return;

      this.fetchAndRenderSection(urlProd); // Sin signal
      this.fetchProductJson(urlProd);      // Sin signal
    }

    async addToCartClickHandler(event) {
      const bodyElement = document.querySelector('body');
      const drawerCart = document.querySelector('#drawer-cart-modal');
      event.preventDefault();
       if (this.elements.termsCheckbox && !this.elements.termsCheckbox.checked) return;

      const form = event.target.closest('form');
      if (!form) return;

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        await response.json();
        bodyElement.style.overflow = 'hidden';
        drawerCart?.classList.add('show-cart-modal');

        if (typeof liquidAjaxCart !== 'undefined') {
          liquidAjaxCart.update();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }

    handleClick(event, button = null) {
      event.preventDefault();

      const btn = button || event.currentTarget;
      const optionName = btn.getAttribute('data-name');
      const optionValue = btn.getAttribute('value');

      this.selectedOptions[optionName] = optionValue;

      const selectedVariant = this.getProductVariant(this.productVariants, this.selectedOptions);

      this.addRemoveClass(`.variant_${optionName}`, btn, 'selected');
      this.updateSizeAvailability();

      if (selectedVariant) {
        this.updateVariantUI(selectedVariant);
      }
      this.toggleShopPayVisibility(selectedVariant.available);
      this.getSelectedVariantById();
    }

    toggleShopPayVisibility(isAvailable) {
      const paymentButton = document.querySelector('.shopify-payment-button');
      const shopPayContainer = document.querySelector('.shop-pay-contianer');
      const toggleAction = isAvailable ? 'remove' : 'add';

      if (paymentButton) paymentButton.classList[toggleAction]('dn-i');
      if (shopPayContainer) shopPayContainer.classList[toggleAction]('dn-i');
    }

    getSelectedVariantById() {
      if (!this.elements.productSelectEl) return null;
      const selectedId = this.elements.productSelectEl.value;
      return this.productVariants.variants.find(variant => String(variant.id) === String(selectedId));
    }

    updateVariantUI(selectedVariant) {
      const { colorSelectedEl, sizeSelectedEl, productSelectEl, onlyLeftInStock, soldButton, backInStock, showRealPrice, showComparePrice, addToCartBtn } = this.elements;

      if (colorSelectedEl) colorSelectedEl.textContent = selectedVariant.options[0];
      if (sizeSelectedEl) sizeSelectedEl.textContent = selectedVariant.options[1];
      if (productSelectEl) productSelectEl.value = selectedVariant.id;

      this.mainContainerColor(selectedVariant.options[0]);

      if (onlyLeftInStock) {
        if (selectedVariant.inventory_quantity > 0 && selectedVariant.inventory_quantity <= 10) {
          onlyLeftInStock.classList.remove('dn-i');
          onlyLeftInStock.classList.add('show-only-left');
          onlyLeftInStock.textContent = `Only ${selectedVariant.inventory_quantity} left!`;
        } else {
          onlyLeftInStock.classList.add('dn-i');
          onlyLeftInStock.classList.remove('show-only-left');
        }
      }

      const variantUrl = this.getUrl.search.split('nosto=').pop();
      if (!variantUrl) {
        history.replaceState(null, 'Title', `${this.getUrl.pathname}?variant=${selectedVariant.id}`);
      }

      if (selectedVariant.available) {
        this.updatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);

        if (selectedVariant.compare_at_price > selectedVariant.price) {
          this.updatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);
          showComparePrice?.forEach(item => item.classList.remove('dn-i'));
          showRealPrice?.forEach(item => item.classList.add('fc-red-lt'));
        } else {
          showComparePrice?.forEach(item => item.classList.add('dn-i'));
          showRealPrice?.forEach(item => item.classList.remove('fc-red-lt'));
        }

        if (addToCartBtn) {
          addToCartBtn.classList.remove('dn-i', 'disabled-add-to-cart');
          // Respect terms checkbox: keep disabled if terms are not accepted
          const termsCheckbox = this.elements.termsCheckbox;
          if (termsCheckbox && !termsCheckbox.checked) {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('disabled-terms');
          } else {
            addToCartBtn.disabled = false;
          }
        }
        soldButton?.classList.add('dn-i');
        backInStock?.classList.add('dn-i');

        history.replaceState(null, 'Title', `${this.getUrl.pathname}?variant=${selectedVariant.id}`);
      } else {
        history.replaceState(null, 'Title', `${this.getUrl.pathname}?variant=${selectedVariant.id}`);

        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled-add-to-cart', 'dn-i');
        }
        soldButton?.classList.remove('dn-i');
        backInStock?.classList.remove('dn-i');
        showRealPrice?.forEach(item => item.classList.remove('fc-red-lt'));
      }
    }

    getProductVariant(product, selectedOptions) {
      const variantOptionCurrent = this.elements.productSelectEl?.selectedOptions[0]?.dataset.variantOptions.split('-') || [];
      const colorSelected = selectedOptions.color || variantOptionCurrent.shift();
      const sizeSelected = selectedOptions.size || variantOptionCurrent.pop();
      const matchText = `${colorSelected} / ${sizeSelected}`;

      const selectedVariant = product.variants.find(variant => variant.title === matchText);

      if (selectedVariant) {
        this.updatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
        const showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');

        if (selectedVariant.compare_at_price > selectedVariant.price) {
          this.updatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);
          showComparePrice.forEach(item => item.classList.remove('dn-i'));
        } else {
          showComparePrice.forEach(item => item.classList.add('dn-i'));
        }
      }

      return selectedVariant;
    }

    setDefaultVariant() {
      const variantUrl = this.getUrl.search.split('?variant=').pop();
      const selectedOptions = document.querySelectorAll('.swatch-btn[selected]');
      const availableVariants = this.elements.productSelectEl?.querySelectorAll('option');

      if (variantUrl && availableVariants && [...availableVariants].some(v => v.value === variantUrl)) {
        this.elements.productSelectEl.value = variantUrl;
        document.querySelector('.variant_size.selected')?.click();
        history.replaceState(null, 'Title', `${this.getUrl.pathname}?variant=${variantUrl}`);
      }

      selectedOptions?.forEach(option => option.click());
    }

    updateSizeAvailability() {
      const color = this.selectedOptions.color;
      const variantSizeEls = document.querySelectorAll('.variant_size');

      variantSizeEls.forEach(sizeEl => {
        const sizeValue = sizeEl.getAttribute('value');
        const variant = this.getProductVariant(this.productVariants, { color: color, size: sizeValue });

        sizeEl.dataset.colorSelected = color;

        if (this.elements.colorSelectedEl) {
          this.elements.colorSelectedEl.dataset.colorSelected = color;
        }

        if (variant && variant.available) {
          sizeEl.classList.remove('sold-out');
        } else {
          sizeEl.classList.add('sold-out');
        }

        sizeEl.textContent = this.cutTheTextContent(sizeEl.dataset.cuttext);
      });
    }

    mainContainerColor(color) {
      const mainContainersColor = document.querySelectorAll('.gallery-main-media');
      const colorSelected = color.replace(/\s+/g, '-').toLowerCase();

      mainContainersColor.forEach(mainContainer => {
        if (mainContainer.classList.value.includes(colorSelected)) {
          mainContainer.classList.remove('dn-i');
        } else {
          mainContainer.classList.add('dn-i');
        }
      });
    }
    accordions() {
      const accordion = document.querySelectorAll('.accordion-pdp');

      accordion.forEach((singleAccordion) => {
        const newAccordion = singleAccordion.cloneNode(true);
        singleAccordion.parentNode.replaceChild(newAccordion, singleAccordion);

        newAccordion.addEventListener('click', () => {
          newAccordion.classList.toggle('active-pdp');
          const panel = newAccordion.nextElementSibling;

          if (panel) {
            if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
          }
        });
      });
    }

    initZoomGallery() {
      const zoomItemsGallery = document.querySelectorAll('.featured-image');
      const zoomGalleryModal = document.querySelector('.zoom-gallery_container');
      const closeButton = document.querySelector('.close-zoom-image-button');

      if (closeButton) {
        // Remove old listener to avoid duplicates if re-initializing
        closeButton.removeEventListener('click', this.closeZoomGallery.bind(this));
        closeButton.addEventListener('click', this.closeZoomGallery.bind(this));
      }

      zoomItemsGallery.forEach((itemZoom) => {
        itemZoom.addEventListener('click', () => {
          document.querySelectorAll('.zoom-gallery-main-media').forEach((item) => item.classList.add('dn-i'));

          if (zoomGalleryModal) zoomGalleryModal.classList.remove('dn-i');
          const imageContainerAttb = itemZoom.closest('.image-container');

          if (!imageContainerAttb) return;

          const colorSearch = imageContainerAttb.getAttribute('color-search');
          const zoomSwiperDiv = document.querySelector(`.zoom-gallery-key-${colorSearch}`);

          if (zoomSwiperDiv) {
            const swiperClass = zoomSwiperDiv.classList[0]; // e.g., zoom-gallery-main-media-black--12345

            // Lazy init the swiper if it doesn't exist
            this.initZoomSwipers(swiperClass);

            let swiperInstance = zoomSwiperDiv.swiper;
            if (!swiperInstance && window.swipers && window.swipers[swiperClass]) {
              swiperInstance = window.swipers[swiperClass];
            }

            if (swiperInstance) {
              zoomSwiperDiv.classList.remove('dn-i');
              swiperInstance.update();

              const indexAttr = imageContainerAttb.getAttribute('data-index-image');
              const dataIndex = indexAttr ? parseInt(indexAttr) - 1 : 0;
              if (!isNaN(dataIndex)) {
                swiperInstance.slideTo(dataIndex);
              }

              setTimeout(() => swiperInstance.update(), 450);
              document.querySelector('body').style.overflow = 'hidden';
            } else {
              // Or maybe the initZoomSwipers failed.
              zoomSwiperDiv.classList.remove('dn-i');
            }
          }
        });
      });
    }

    initZoomSwipers(swiperClass) {
      const swiperContainer = document.querySelector(`.${swiperClass}`);
      if (!swiperContainer) return;

      // Check if already initialized
      if (swiperContainer.classList.contains('swiper-initialized')) return;

      // Extract color search from data attribute or class structure if needed
      // The liquid code generated specific classes for next/prev buttons
      const colorSelect = swiperContainer.getAttribute('data-color-select');

      try {
        new Swiper(swiperContainer, {
          slidesPerView: 1,
          allowTouchMove: true,
          navigation: {
            nextEl: `.swiper-button-next-zoom-${colorSelect}`,
            prevEl: `.swiper-button-prev-zoom-${colorSelect}`,
          },
          pagination: {
            el: `.${swiperClass} .swiper-pagination`,
            clickable: true,
          },
        });
        console.log(`Lazy initialized swiper for ${swiperClass}`);
      } catch (e) {
        console.error('Error initializing zoom swiper', e);
      }
    }

    closeZoomGallery() {
      const zoomGalleryContainer = document.querySelector('.zoom-gallery_container');
      if (zoomGalleryContainer) {
        zoomGalleryContainer.classList.add('dn-i');
        document.querySelector('body').style.overflow = 'auto';
      }
    }

    addRemoveClass(optionName, selected, active) {
      const container = document.querySelectorAll(optionName);
      container.forEach(item => item.classList.remove(active));
      selected.classList.add(active);
    }

    updatePriceVariant(items, price) {
      const container = document.querySelectorAll(items);
      container.forEach(item => {
        item.innerHTML = `${window.currencySymbol}${(price / 100).toFixed(2)}`;
      });
    }

    cutTheTextContent(textContent) {
      const decimal = /^[+-]?\d+(\.\d+)?$/;
      if (textContent.includes('/')) return textContent;
      if (textContent.includes('$')) return textContent.slice(0, -3);
      if (decimal.test(textContent)) return textContent;
      return textContent.replace(/[^A-Z]/g, '');
    }

    removeAccordionEmpty() {
      document.querySelectorAll('.accordion-content').forEach(item => {
        if (item.children.length === 0) {
          item.classList.add('dn-i');
        }
      });
    }

    async handleProductCircleClick(event, item) {
      event.preventDefault();
      event.stopPropagation();

      const urlProd = item.getAttribute('href');
      const productTitle = item.getAttribute('data-product-title');

      if (this.currentFetchingUrl === urlProd) {
        console.log(`⚠️ Already fetching ${urlProd}, ignoring click.`);
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.currentFetchingUrl = urlProd;

      history.replaceState(null, '', urlProd);
      console.log(history.state);

      const productLabel = document.querySelector('.products-print-label');
      if (productLabel) {
        productLabel.innerHTML = '<h4 class="fw600 sans-light-pdp f16px mb0 pb2 f15pxm">Print: <span class="fw400 f16px sans-light-pdp f15pxm">' + productTitle + '</span></h4>';
      }

      document.body.style.cursor = 'wait';

      try {
        const [docRes, productData] = await Promise.all([
          this.fetchAndRenderSection(urlProd, this.abortController.signal),
          this.fetchProductJson(urlProd, this.abortController.signal)
        ]);

        if (!docRes) {
          console.error('Cannot render the product info');
          return;
        }

        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const renderSections = [
          isMobile ? '.product-pdp-gallery-media--mobile' : '.product-pdp-gallery-media--desktop',
          '.info-product-detail__container',
          '#featured-product-form',
          '.custom-products-section',
          '.zoom-gallery_container',
          '.size-chart-acf',
          '.featured-details',
          '.related-products--container',
          '.meet-people--container',
          '.accordion-container'

        ];

        await this.renderSection(docRes, renderSections);

        if (productData) {
          this.productVariants = productData;
        }

        this.init();

        // Auto-select first available variant
        if (this.productVariants && this.productVariants.variants) {
          const firstAvailable = this.productVariants.variants.find(v => v.available);
          if (firstAvailable) {
            const color = firstAvailable.options[0];
            const size = firstAvailable.options[1];

            if (color) {
              const colorBtn = document.querySelector(`.variant_color[value="${color}"]`);
              if (colorBtn) colorBtn.click();
            }
            if (size) {
              const sizeBtn = document.querySelector(`.variant_size[value="${size}"]`);
              if (sizeBtn) sizeBtn.click();
            }
          }
        }

      } catch (e) {
        if (e.name === 'AbortError') {
          console.log('Fetch aborted successfully');
          return;
        }
        console.error('Error rendering product', e);
      } finally {
        document.body.style.cursor = 'default';
        this.abortController = null;
        this.currentFetchingUrl = null;
      }
    }

    async fetchProductJson(url, signal = null) {
      const cacheKey = `${url}.js`;

      if (this.cache.has(cacheKey)) {
        this.cacheAccessOrder = this.cacheAccessOrder.filter(k => k !== cacheKey);
        this.cacheAccessOrder.push(cacheKey);
        return this.cache.get(cacheKey);
      }

      const fetchPromise = (async () => {
        try {
          const response = await fetch(cacheKey, { signal });
          if (!response.ok) throw new Error('Network error');
          return await response.json();
        } catch (error) {
          if (error.name === 'AbortError') {
            // Clean cache on abort so next try is fresh
            this.cache.delete(cacheKey);
            throw error;
          }
          console.error('Error fetching JSON:', error);
          this.cache.delete(cacheKey); // Clean cache on error
          return null;
        }
      })();

      this.addToCache(cacheKey, fetchPromise);
      return fetchPromise;
    }
    async renderSection(doc, sections) {
      // Renderizar en micro-batches para evitar bloqueo
      for (const section of sections) {
        const sectionHTML = doc.querySelector(section);
        if (sectionHTML) {
          const sectionRendered = document.querySelector(section);
          if (sectionRendered) {
            // Usar requestAnimationFrame para no bloquear
            await new Promise(resolve => {
              requestAnimationFrame(() => {
                sectionRendered.innerHTML = sectionHTML.innerHTML;
                resolve();
              });
            });
          }
        }
      }
    }

    async fetchAndRenderSection(url, signal = null) {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      const separator = url.includes('?') ? '&' : '?';
      const mobileSection = isMobile ? 'featured-product-gallery-mobile' : 'featured-product-gallery';
      const templateTrip = document.querySelector('body').classList.contains('template-pdp-featured-trip');
      const productDetailSection = templateTrip ? 'featured-product-detail-trip' : 'featured-product-detail';

      const sectionUrl = `${url}${separator}sections=${mobileSection},${productDetailSection},size-chart,related-products,meet-people-module`;

      if (this.cache.has(sectionUrl)) {
        return this.cache.get(sectionUrl);
      }

      const fetchPromise = (async () => {
        try {
          const response = await fetch(sectionUrl, { signal });

          const json = await response.json();

          let combinedHTML = '';
          Object.values(json).forEach(html => {
            combinedHTML += html;
          });

          const parser = new DOMParser();
          return parser.parseFromString(combinedHTML, 'text/html');
        } catch (error) {
          if (error.name === 'AbortError') {
            this.cache.delete(sectionUrl);
            throw error;
          }
          console.error('Error fetching section:', error);
          this.cache.delete(sectionUrl); // Clean cache on error
          return null;
        }
      })();

      this.addToCache(sectionUrl, fetchPromise);
      return fetchPromise;
    }

    handleScroll() {
      if (!this.headerDiv) this.headerDiv = document.querySelector('#header');
      if (!this.stickyContainer) this.stickyContainer = document.querySelector('.main-container-pdp .info-container');


      if (this.headerDiv && this.stickyContainer) {
        if (this.headerDiv.classList.contains('stuck') &&
          this.headerDiv.classList.contains('tuck') &&
          this.headerDiv.classList.contains('untuck')) {
          this.stickyContainer.style.top = '115px';
        } else {
          this.stickyContainer.style.top = '5px';
        }
      }

      this.checkFloatingVisibility();
    }

    isElementInViewport(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

      return (
        (rect.top) < windowHeight &&
        (rect.bottom + 10) > 0 &&
        rect.left < windowWidth &&
        rect.right > 0
      );
    }

    checkFloatingVisibility() {
      const { floatingAddToCarBtn, addToCartBtn, footer } = this.elements;

      if (!floatingAddToCarBtn || !addToCartBtn) return;

      if (!addToCartBtn.classList.contains('disabled-add-to-cart')) {
        if (!this.isElementInViewport(addToCartBtn)) {
          if (addToCartBtn.getBoundingClientRect().top < 0) {
            floatingAddToCarBtn.style.display = 'block';
          }
        } else {
          floatingAddToCarBtn.style.display = 'none';
        }

        if (footer && this.isElementInViewport(footer)) {
          floatingAddToCarBtn.style.display = 'none';
        }
      } else {
        floatingAddToCarBtn.style.display = 'none';
      }
    }

    destroy() {
      document.removeEventListener('scroll', this.handleScroll);

      const variantContainer = document.querySelector('.product-form__controls-group') || document.body;
      if (this.variantDelegateHandler) {
        variantContainer.removeEventListener('click', this.variantDelegateHandler);
      }

      const productCircleContainer = document.querySelector('.product-circles') || document.body;
      if (this.productCircleDelegateHandler) {
        productCircleContainer.removeEventListener('click', this.productCircleDelegateHandler);
      }

      const galleryContainer = document.querySelector('.product-pdp-gallery-media') || document.body;
      if (this.galleryTagDelegateHandler) {
        galleryContainer.removeEventListener('click', this.galleryTagDelegateHandler);
      }

      // Destruir todos los swipers
      this.destroyAllSwipers();
    }
  }

  function waitForElement(selector) {
    return new Promise(resolve => {
      const element = document.querySelector(selector);
      if (element) {
        return resolve(element);
      }

      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  function renderYotpoRatingCount() {
    const yotpoRatings = document.querySelectorAll('.card-related-product__content-rating .yotpo-bottomline .text-m');

    yotpoRatings.forEach(rating => {
      const cutTextRating = rating.getAttribute('aria-label')?.split(' ').shift();
      if (cutTextRating) {
        rating.textContent = `(${cutTextRating})`;
      }
    });
  }

  function openCloseModalG(modal, action) {
    const sizeChart = document.querySelector(modal);
    if (action) {
      sizeChart?.classList.add('size-chart-show');
    } else {
      sizeChart?.classList.remove('size-chart-show');
    }
  }

  function hideElementOnEsc(elementSelector, keyCode, classNameToAdd, isAdd, carousel) {
    const element = document.querySelector(elementSelector);

    if (!element) {
      console.error(`Element not found with selector: ${elementSelector}`);
      return;
    }

    const handleKeydown = (event) => {
      if (event.keyCode === keyCode) {
        const body = document.querySelector('body');

        if (!element.classList.contains(classNameToAdd) && isAdd) {
          element.classList.add(classNameToAdd);
          body.style.overflow = 'auto';
        } else if (element.classList.contains(classNameToAdd) && !isAdd) {
          element.classList.remove(classNameToAdd);
          body.style.overflow = 'auto';

          if (carousel && typeof $ !== 'undefined' && $(carousel).hasClass('slick-initialized')) {
            $(carousel).slick('unslick');
          }
        }
      }
    };

    document.removeEventListener('keydown', handleKeydown);
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.productManager = new ProductManager();
    });
  } else {
    window.productManager = new ProductManager();
  }

  waitForElement('.standalone-bottomline .yotpo-stars').then(() => {
    setTimeout(renderYotpoRatingCount, 2000);
  });

  waitForElement('.container-infinite').then(() => {
    hideElementOnEsc('.container-infinite', 27, 'dn-i', true);
  });

  waitForElement('.zoom-gallery_container').then(() => {
    hideElementOnEsc('.zoom-gallery_container', 27, 'dn-i', true);
  });

  waitForElement('.size-chart-acf__modal').then(() => {
    hideElementOnEsc('.size-chart-acf__modal', 27, 'dn-i', true);
  });
})();